const pathForCase = "/meshstats/covid19/api.php"
const pathForInfection = "/meshstats/covid19/paramapi.php"
function convertId(prefectureId) {
  var id = prefectureId.toString()
  if (prefectureId < 10) {
    id = '0' + id
  }
  return id
}

function paramForCase(prefectureId, isObservation, isDiff) {
  return {
    mode: "csv",
    type: isObservation ? 'observation' : "simulation",
    diff: isDiff ? "T" : "F",
    prefcode: convertId(prefectureId)
  }
}

function paramForInfection(prefectureId) {
  return {
    prefcode: convertId(prefectureId)
  }
}

function parseLines(lines) {
  return lines.map(line => {
    return {
      date: line[0],
      value: line[1]
    }
  })
}

function createUrlFor(dataType, dataId, isDiff) {
  var urlString = window.location.protocol + "//" + window.location.hostname;
  if (window.location.port.length > 0) {
    urlString += ":" + window.location.port;
  }
  var params = "";
  switch (dataType) {
    case "simulation":
      urlString += pathForCase;
      params = paramForCase(dataId, false, isDiff);
      break;
    case "observation":
      urlString += pathForCase;
      params = paramForCase(dataId, true, isDiff);
      break;
    case "infection":
      urlString += pathForInfection;
      params = paramForInfection(dataId);
      break;
    default:
      throw 'Wrong Data Type !!';
  }
  window.console.log(params);
  var url = new URL(urlString);
  url.search = new URLSearchParams(params).toString();
  return url;
}

function convertResponseToData(response) {
  var lines = response.split(/\r\n|\r|\n/).map(line => line.split(/,|\t| /))
  lines.splice(0, 1)[0]
  return parseLines(lines)
}

function fetchCovid19Data(params, callback) {
  Promise.all([
    fetch(createUrlFor("simulation", params.prefectureId, params.isDiff)).then(response => { return response.text(); }),
    fetch(createUrlFor("infection", params.prefectureId, params.isDiff)).then(response => { return response.text(); }),
    fetch(createUrlFor("observation", params.prefectureId, params.isDiff)).then(response => { return response.text(); }),
  ]).then(([responseCase, responseInfection, responseObservation]) => {
    const caseData = convertResponseToData(responseCase)
    const infectionData = convertResponseToData(responseInfection)
    const observationData = convertResponseToData(responseObservation)
    callback(caseData, infectionData, observationData)
  }).catch((errors) => {
    window.console.log(errors);
  });
}

let api = {
  fetchCovid19Data,
}
export { api as default }
